import { ButtonProps, CircularProgress } from '@mui/material';
import React, { ReactNode } from 'react';
import { BaseButton } from './BaseButton';
import styles from './Button.module.scss';

export type Width = 'small' | 'medium' | 'large';

export interface AppButtonProps {
	children?: ReactNode;
	text?: string;
	fontWeight?: string | number;
	fontSize?: string;
	width?: Width | string;
	loading?: boolean;
	loaderSize?: string | number;
	wrapText?: boolean;
	minWidth?: string;
}

export const AppButton: React.FC<AppButtonProps & ButtonProps> = ({
	children,
	text,
	type = 'button',
	width = 'normal',
	fontWeight = 700,
	fontSize = '0.875rem',
	loading,
	loaderSize,
	wrapText,
	variant = 'contained',
	color = 'primary',
	size = 'large',
	...props
}) => {
	const getClasses = () => {
		let classes = [props.className];

		if (!props.fullWidth && ['small', 'medium', 'large'].includes(width)) {
			classes.push(styles[width]);
		}
		return classes.join(' ');
	};

	return (
		<BaseButton
			{...props}
			className={getClasses()}
			fontWeight={fontWeight}
			fontSize={fontSize}
			wrapText={wrapText}
			type={type}
			variant={variant}
			color={color}
			size={size}
		>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				{loading ? <CircularProgress size={loaderSize} style={{ color: 'white' }} /> : children || text}
			</div>
		</BaseButton>
	);
};
